import * as React from 'react';
import gql from 'graphql-tag';
import {graphql, InjectedGraphQLProps} from 'react-apollo';
import {Component, deps, inject, observer} from '../../lib/component';
import {classes, style} from 'typestyle';
import {important, px, rem} from 'csx';
import {centerCenter} from 'csstips';
import maybe from '../../lib/maybe';
import {SimilarTrack, Track} from '../../types/graphql';
import {colorSubtle} from '../../theme/color';
import {ReleaseTracks, ReleaseTracksModel} from '../release-tracks';
import {BrandSponsoredLabelCompat} from '../compat/brand-sponsored-label-compat';
import {PlayButtonCompat} from '../compat/play-button-compat';
import {FavouriteButtonCompat} from '../compat/favourite-button-compat';
import {AddRemoveCompat} from '../compat/add-remove-compat';
import {Loading} from '../loading/loading';

type Props = {
  identity: string;
}

type Data = {
  getTrack: Track
}

type CombinedProps = Props & InjectedGraphQLProps<Data>;

@inject(deps) @observer
class TrackSimilarTracks extends Component<CombinedProps> {
  render() {
    const {data} = this.props;
    const {handleClickLink} = this.props.controller.ui;
    const {preloadWaveformSvg} = this.props.controller.image;
    const {isMobile} = this.props.model.ui;

    if (data.loading) return (
      <div className={classes(TrackSimilarTracks.styles.container, TrackSimilarTracks.styles.loading)}>
        <Loading size={32} />
      </div>
    );

    const similar = maybe(
      () => data.getTrack!.similar!,
      []
    );

    return (
      <ReleaseTracks
        analytics={this.props.controller.analytics}
        model={TrackSimilarTracks.releaseTracksModel(similar)}
        AddRemove={AddRemoveCompat}
        PlayButton={PlayButtonCompat}
        Favourite={FavouriteButtonCompat}
        BrandSponsoredLabel={BrandSponsoredLabelCompat}
        isMobile={isMobile}
        onClickLink={handleClickLink}
        preloadWaveform={preloadWaveformSvg}
      />
    )
  }

  static releaseTracksModel = (tracks: SimilarTrack[] | null): ReleaseTracksModel => ({
    loading: false,
    tracks: tracks
      ? tracks.filter(t => !!t.track).map(t => t.track as any)
      : [],
  });

  static styles = {
    container: style({
      zIndex: 1,
      background: colorSubtle.fade(0.075).toString(),
      padding: rem(1),
      borderRadius: rem(1),
      $nest: {
        '& h3': {
          margin: '1.5rem 0 1rem'
        },
        '& h3:first-child': {
          margin: '0 0 1rem 0'
        }
      }
    }),
    loading: style({
      ...centerCenter,
      width: important('100%'),
      minHeight: px(240)
    })
  };
}

export default TrackSimilarTracks;

export const ConnectedTrackSimilarTracks = graphql(gql`
  query (
    $identity: ID!
  ) {
    getTrack(options:{identity:$identity}) {
      similar {
        track {
          audition_point
          identity
          title
          slug
          duration
          created_at
          is_charting
          is_featured
          is_new_release
          brand_sponsored
          branded_content
          audio {
            identity
          }
          images {
            identity
          }
          artists {
            images {
              identity
            }
            name
            slug
            identity
          }
        }
      }
    }
  }
`, {
  options: (variables: Props) => ({
    variables,
    // fetchPolicy: 'network-only'
  }),
})(TrackSimilarTracks);